import gql from 'graphql-tag';

/**
 * @returns {gql fragment}
 */

const PageInfoFragment = gql`
  fragment PageInfoFragment on PageInfo {
    count
    resultsInPage
    pageNo
    lastPageNo
  }
`;

export default PageInfoFragment;



// WEBPACK FOOTER //
// ./src/apolloConst/fragments/PageInfoFragment.js